import React, { useState, useEffect } from "react";
import Button from "../../components/global/Button";
import TransparentCard from "../../components/global/TransparentCard";
import LastTransaction from "../../components/homeSection/LastTransaction";
import { useTranslation } from "react-i18next";
import { fetchTracks } from "../../services/api";
import { bookingUrlWithFromRsSite } from "../../utils/bookingFromSiteUrl";

const HeroSection = () => {
  const { t } = useTranslation();
  const [heroTracks, setHeroTracks] = useState([]);

  useEffect(() => {
    fetchTracks()
      .then((data) => {
        // Фільтруємо тільки треки з позначкою "показати в hero"
        const filtered = data.filter((track) => track.show_in_hero);
        setHeroTracks(filtered);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="conatiner heroSection">
      <div className="hero-section">
        <div className="hero-main">
          <h3>{t("welcome")}</h3>
          <h1>Roger Sounds</h1>
          <p>{t("greeting")}</p>
          <Button extraP={"32px"} path={bookingUrlWithFromRsSite()} />
        </div>
        <div className="hero-main-bottom">
          <TransparentCard tracks={heroTracks} />
          <LastTransaction />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
